import { createTheme } from '@mui/material/styles';

const brandPalette = {
  primary: {
    dark: '#3741af',
    main: '#4f5efa',
    light: '#727efb',
  },
  secondary: {
    dark: '#b29420',
    main: '#ffd42f',
    light: '#ffdc58',
  },
};

export const appTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: {
    dark: {
      palette: {
        ...brandPalette,
        text: {
          primary: '#C9D1D9',
          secondary: '#8B949E',
        },
      },
    },
  },
  defaultColorScheme: 'dark',
  typography: {
    h1: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: 600,
      color: '#C9D1D9',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#8B949E',
    },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        fullWidth: true,
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderColor: '#21262D',
          '--DataGrid-rowBorderColor': '#21262D',
          '& .MuiDataGrid-cell': {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#C9D1D9',
            paddingTop: '0.75rem',
            paddingBottom: '0.75rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
          },
        },
        columnHeaders: {
          backgroundColor: '#161B22',
          borderBottomColor: '#21262D',
        },
        columnHeader: {
          backgroundColor: '#161B22',
          '&:focus': {
            outline: 'none',
          },
          '&:focus-within': {
            outline: 'none',
          },
        },
        columnHeaderTitle: {
          fontSize: '0.75rem',
          lineHeight: '1rem',
          fontWeight: 500,
          letterSpacing: '0.05em',
          color: '#8B949E',
        },
        row: {
          borderBottomColor: '#21262D',
        },
        cell: {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          color: '#C9D1D9',
          paddingTop: '0.75rem',
          paddingBottom: '0.75rem',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          borderColor: '#21262D',
          display: 'flex',
          alignItems: 'center',
          '&:focus': {
            outline: 'none',
          },
        },
      },
    },
  },
});
